module.exports = __webpack_public_path__ + "img/mongodb.c2a864c9.svg";